import React, { Component } from "react";
import { NavLink, Route, Switch } from "react-router-dom";

// CSS
import "../../styles/authPage.scss";

// Components
// No Header or Footer: an auth screen is its own place, with the sheet filling
// the viewport, exactly as the dashboard's own Join screen is built.
import Icon from "../../components/Icon";
import AuthAside from "../../components/AuthAside/AuthAside";
import SignIn from "../SignIn/SignIn";
import SignUp from "../SignUp/SignUp";

// Helper
import { resolveTenant, cachedTenant } from "../../Helper/Api";
import { t } from "../../Helper/i18n";

// One route serves both /sign-in and /sign-up, so moving between them swaps
// only the form. Two separate routes meant React unmounted the whole screen
// on every switch: the tenant was fetched again and the ground, the halo, the
// sheet and the whole white half replayed their entrance -- which read as a
// page reload, because that is what it looked like.
//
// The shell lives here and stays mounted; the nested Switch below is the only
// part that changes.
class AuthLayout extends Component {
  state = {
    tenant: cachedTenant(),
    notFound: false,
  };

  componentDidMount() {
    resolveTenant()
      .then((tenant) => this.setState({ tenant }))
      .catch(() => this.setState({ notFound: true }));
  }

  render() {
    const { tenant, notFound } = this.state;
    const onSignUp = this.props.location.pathname === "/sign-up";

    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>{t("notFound")}</p>
          </div>
        </div>
      );
    }
    if (!tenant) return null;

    return (
      <div className="au-page mu mu-ground">
        <div className="au-sky" aria-hidden="true">
          <span className="aur a1"></span>
          <span className="aur a2"></span>
          <span className="dots"></span>
          <span className="gh g1"><Icon name="play" /></span>
          <span className="gh g2"><Icon name="book" /></span>
          <span className="gh g3"><Icon name="chart" /></span>
          <span className="gh g4"><Icon name="award" /></span>
        </div>

        <div className="au-halo mu-halo">
          <div className="au-sheet mu-sheet">
            {/* white half: what the account is for. Only the closing clause of
                the lede differs between the two, so nothing here moves. */}
            <AuthAside
              tenant={tenant}
              lede={t("authLede", { after: onSignUp ? t("authAfterSignUp") : t("authAfterSignIn") })}
            />

            {/* teal half: the only part that changes between the two routes */}
            <div className="au-panel">
              <div className="au-face">
                <div className="au-tabs">
                  <NavLink to="/sign-in" activeClassName="is-on">{t("login")}</NavLink>
                  <NavLink to="/sign-up" activeClassName="is-on">{t("createAccount")}</NavLink>
                </div>

                <Switch>
                  <Route path="/sign-in" exact>
                    <SignIn tenant={tenant} />
                  </Route>
                  <Route path="/sign-up" exact>
                    <SignUp tenant={tenant} />
                  </Route>
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AuthLayout;
